import { AttatchFileForContactContainer } from "../../../containers/borrowSystem/Contact/AttatchFileForContactContainer";
export function AttatchFileForContactPage() {

  return (
      <AttatchFileForContactContainer/>
  );
}
